export default __webpack_public_path__ + "static/media/109_mobile.b4b7f8b2.jpg";